import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LyRipple } from 'alyle-ui/ripple-minimal';
import { Platform } from 'alyle-ui/core';
import { ChangeDetectionStrategy } from '@angular/core';
var LyIconButton = /** @class */ (function () {
    function LyIconButton(elementRef) {
        this.elementRef = elementRef;
        this._size = '24px';
        if (Platform.isBrowser) {
            this.nativeElement = this.elementRef.nativeElement;
            if (this.nativeElement.nodeName.toLowerCase() === 'ly-icon-button') {
                console.log("ly-icon-button:", this.nativeElement, " is deprecated instead use button[ly-icon-button]");
            }
        }
    }
    Object.defineProperty(LyIconButton.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (val) {
            if (typeof val === 'number') {
                this._size = val + "px";
            }
            else {
                this._size = val;
            }
            this._updateSize();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyIconButton.prototype, "iconStyle", {
        get: function () {
            return this._iconStyle;
        },
        set: function (style) {
            this.assignStyle(style);
        },
        enumerable: true,
        configurable: true
    });
    LyIconButton.prototype.assignStyle = function (newStyle) {
        this._iconStyle = Object.assign(this.iconStyle || {}, newStyle);
    };
    LyIconButton.prototype.ngOnChanges = function (changes) {
        // #
    };
    LyIconButton.prototype.ngOnInit = function () {
        if (!this.iconStyle) {
            this._updateSize();
        }
    };
    LyIconButton.prototype._updateSize = function () {
        var wh = "calc(" + this._size + " * 2)";
        var style = {
            'width': wh,
            'height': wh,
            'font-size': this._size
        };
        this.assignStyle(style);
    };
    LyIconButton.prototype.ngAfterViewInit = function () {
        if (Platform.isBrowser) {
            this.ripple.lyRippleDisabled = true;
            this.ripple.rippleContainer.setTriggerElement(this.nativeElement);
            this.ripple.rippleContainer.setContainerElement(this.nativeElement);
            this.ripple.lyRippleDisabled = false;
        }
    };
    LyIconButton.prototype.ngOnDestroy = function () { };
    LyIconButton.decorators = [
        { type: Component, args: [{
                    selector: 'button[ly-icon-button], a[ly-icon-button], ly-icon-button',
                    styles: [":host { user-select: none; -webkit-tap-highlight-color: transparent; display: inline-flex; background: transparent; border: 0; padding: 0; cursor: pointer; outline: none; box-sizing: border-box; color: currentColor; } .ly-icon-button-content { display: inline-flex; justify-content: center; align-items: center; } .ly-icon-button-content ::ng-deep [ly-svg], .ly-icon-button-content ::ng-deep ly-svg { width: 100%; height: 100%; } "],
                    template: "\n  <div class=\"ly-icon-button-content\" [ngStyle]=\"iconStyle\"\n  lyRipple\n  lyRippleSensitive\n  lyRippleCentered\n  lyRippleRadius=\"containerSize\"\n  >\n    <ng-content></ng-content>\n  </div>\n  ",
                    preserveWhitespaces: false,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    exportAs: 'lyIconButton'
                },] },
    ];
    /** @nocollapse */
    LyIconButton.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    LyIconButton.propDecorators = {
        "ripple": [{ type: ViewChild, args: [LyRipple,] },],
        "size": [{ type: Input, args: ['size',] },],
        "iconStyle": [{ type: Input },],
    };
    return LyIconButton;
}());
export { LyIconButton };
//# sourceMappingURL=icon-button.js.map